export default __webpack_public_path__ + "static/media/productImageYellow.4eb4d76a.png";